import { NAVIGATION_ROUTES } from "../../../utils/NavigationUtils";

export const campaignClonePath = (campaignId: string): string =>
  `${NAVIGATION_ROUTES.DYNAMIC_BONUS_CAMPAIGN_NEW}?cloneFrom=${encodeURIComponent(campaignId)}`;

export const templateClonePath = (templateId: string): string =>
  `${NAVIGATION_ROUTES.DYNAMIC_BONUS_TEMPLATE_NEW}?cloneFrom=${encodeURIComponent(templateId)}`;
